export const RENTER_LEASE_SITUATION_OPTION_FIRM = 'firm';
export const RENTER_LEASE_SITUATION_OPTION_MONTH_TO_MONTH = 'monthToMonth';
export const RENTER_LEASE_SITUATION_OPTION_NO_LEASE = 'noLease';

const leaseSituationOptionItems = [
  {
    label: 'I have a firm lease end-date',
    value: RENTER_LEASE_SITUATION_OPTION_FIRM,
  },
  {
    label: 'I have a month to month lease',
    value: RENTER_LEASE_SITUATION_OPTION_MONTH_TO_MONTH,
  },
  {
    label: 'I don\'t have a lease',
    value: RENTER_LEASE_SITUATION_OPTION_NO_LEASE,
  },
];

export const leaseSituationShortOptionItems = [
  {
    label: 'Firm lease end-date',
    value: RENTER_LEASE_SITUATION_OPTION_FIRM,
  },
  {
    label: 'Month-to-month',
    value: RENTER_LEASE_SITUATION_OPTION_MONTH_TO_MONTH,
  },
  {
    label: 'No lease',
    value: RENTER_LEASE_SITUATION_OPTION_NO_LEASE,
  },
];

export const RENTER_LEASE_SITUATION_OPTION_TO_LABEL_MAPPING = {
  [RENTER_LEASE_SITUATION_OPTION_FIRM]: 'Firm',
  [RENTER_LEASE_SITUATION_OPTION_MONTH_TO_MONTH]: 'Month To Month',
  [RENTER_LEASE_SITUATION_OPTION_NO_LEASE]: 'No Lease',
};

export default leaseSituationOptionItems;
